export const DefaultWorkOrderTypes = {
  PARTTYPE_ORIENTED:'PARTTYPE_ORIENTED',
  KITTYPE_ORIENTED:'KITTYPE_ORIENTED'
};

export function getDefaultWorkOrderType(orgPreferences) {
  return orgPreferences.systemDefaultWorkOrderType ? orgPreferences.systemDefaultWorkOrderType : DefaultWorkOrderTypes.PARTTYPE_ORIENTED;
}
